import { render, staticRenderFns } from "./Notaire.vue?vue&type=template&id=ce68f4b2&"
import script from "./Notaire.vue?vue&type=script&lang=js&"
export * from "./Notaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports